const handler = ( $ ) => {
	const $langSwitcher = $( '.lang-switcher' ),
		$select = $( 'select.gt_selector', $langSwitcher );

	let $label;

	if ( $select.length == 0 ) {
		return;
	}

	// Selectric config
	$select.selectric( {
		responsive: true,
		expandToItemText: true,
		maxHeight: 365,
	} );

	const selectricInitHandler = function ( e, element, selectric ) {
		$label = $( selectric.elements.label );

		const shortLang = $label.text().slice( 0, 3 );

		$label
			.text( shortLang )
			.addClass( 'has-down-arrow has-down-arrow--small' );

		const $li = selectric.$li;

		$li.addClass( 'notranslate' );
		$( $li[ 0 ] ).hide();

		$( selectric.elements.wrapper ).addClass( 'notranslate' );
	};

	const selectricOpenHandler = function ( e, element, selectric ) {
		$label.addClass( 'has-down-arrow--up' );
	};

	const selectricCloseHandler = function ( e, element, selectric ) {
		$label.removeClass( 'has-down-arrow--up' );
	};

	const selectricChangeHandler = function ( e, element, selectric ) {
		selectric.$li.addClass( 'notranslate' );

		if ( typeof window.doGTranslate != 'undefined' ) {
			doGTranslate( selectric.$element.val() );

			const $label = $( selectric.elements.label ),
				shortLang = $label.text().slice( 0, 3 );

			$label.text( shortLang );
		}
	};

	$select.on( 'selectric-init', selectricInitHandler );
	$select.on( 'selectric-open', selectricOpenHandler );
	$select.on( 'selectric-close', selectricCloseHandler );
	$select.on( 'selectric-change', selectricChangeHandler );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
